// The gateway accepts URL-safe-no-pad in path/query segments (`share_id`, `client_hash`,
// `user_hash`) and emits standard-padded in response bodies (`client_id`, `user_id`). The two
// alphabets are not interchangeable; mixing them is a silent 404. Conversion is mechanical:
// `+`->`-`, `/`->`_`, strip `=` padding.

export function toUrlSafeNoPad(stdBase64: string): string {
  return stdBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function toStdBase64(urlSafe: string): string {
  const replaced = urlSafe.replace(/-/g, '+').replace(/_/g, '/');
  const padNeeded = (4 - (replaced.length % 4)) % 4;
  return replaced + '='.repeat(padNeeded);
}

// `event_id` crosses the wire in two encodings (WIRE-CONTRACT §ids): a UUID string on write,
// standard padded base64 of the UUID's 16 bytes on read. This maps write-form to read-form so
// ownership checks are string equality.
export function uuidToWireEventId(uuid: string): string {
  const hex = uuid.replace(/-/g, '');
  if (!/^[0-9a-fA-F]{32}$/.test(hex) || !/^[^-]{8}-[^-]{4}-[^-]{4}-[^-]{4}-[^-]{12}$/.test(uuid)) {
    throw new Error(`not a canonical hyphenated UUID: ${uuid}`);
  }
  const bytes = new Uint8Array(16);
  for (let i = 0; i < 16; i++) bytes[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  let bin = '';
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin);
}
